import React, { useState } from 'react';
import '../royal.css'; 

const SilverSeaForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "‎ ",
    email: "",
    mobile: "",
    leadsource: "Silversea Form",
    monthOfTravel: "",
    passengers: "",
    destination: ""
  });
  const [showPopup, setShowPopup] = useState(false);  
  const [loading, setLoading] = useState(false);  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }

    setLoading(true);  

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbz95shJWvtp20S-ECiBqivronRy-0zne2Psi2CTbADRXhlkQcnqqk_gMUOLkcJNFcNu/exec", {
        method: "POST",
        body: form
      });

      if (response.ok) {
        setShowPopup(true);  
      } else {
        alert("There was an error submitting the form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form!");
    } finally {
      setLoading(false); 
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="form-box">
        <h2 className="form-title">REQUEST A SILVERSEA CRUISE QUOTE</h2>

        <div className="form-group">
          <label>Name *</label>
          <input
            type="text"
            name="firstName"
            onChange={handleChange}
            placeholder="Full Name"
            required
          />
        </div>

        <div className="form-group">
          <label>Email *</label>
          <input
            type="email"
            name="email"
            onChange={handleChange}
            placeholder="Email"
            required
          />
        </div>

        <div className="form-group">
          <label>Phone *</label>
          <input
            type="tel"
            name="mobile"
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Number of Travellers</label>
          <input
            type="number"
            name="passengers"
            onChange={handleChange}
            placeholder="Number of Travellers"
          />
        </div>

        <div className="form-group">
          <label>Travel Month</label>
          <input
            type="date"
            name="monthOfTravel"
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Destination *</label>
          <input
            type="text"
            name="destination"
            onChange={handleChange}
            placeholder="Destination"
            required
          />
        </div>

        <button type="submit" className="submit-button" disabled={loading}>
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </form>

      {/* Popup Animation */}
      {showPopup && (
        <div className="popup-container">
          <div className="popup-content">
            <h3>Thank you for your submission!</h3>
            <p>We will get back to you soon.</p>
            <button onClick={() => setShowPopup(false)} className="close-popup">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SilverSeaForm;
